import { ALL_TIME_RANGE_QUERY } from 'consts/filterOptions'
import getUploadDateByValue from 'utils/getUploadDateByValue'
import { getFormatedDateVariablesForTerritory } from 'utils/territoryUtils'

import type {
  TBrandedVsUgcMetric,
  TBrandedVsUgcMetrics,
  TBrandedVsUgcNiche,
  TBrandedVsUgcSide,
} from './use-niches-branded-vs-ugc.types'

export const valueByMetric = (
  niche: TBrandedVsUgcNiche,
  metric: TBrandedVsUgcMetric,
  side: TBrandedVsUgcSide
): number => {
  const getValueFromMetrics = (metrics: TBrandedVsUgcMetrics) => {
    switch (metric) {
      case 'engagement':
        return metrics.totalEngagement
      case 'engagement-avg':
        return metrics.avgEngagement
      case 'views':
        return metrics.totalViews
      case 'views-avg':
        return metrics.avgViews
      case 'videos':
        return metrics.totalPosts
      default:
        return 0
    }
  }

  if (side === 'total') {
    const brandedValue = getValueFromMetrics(niche.brandedMetrics)
    const ugcValue = getValueFromMetrics(niche.ugcMetrics)
    return brandedValue + ugcValue
  }

  const metrics: TBrandedVsUgcMetrics = side === 'branded' ? niche.brandedMetrics : niche.ugcMetrics
  return getValueFromMetrics(metrics)
}

export const sortNichesByMetric = (
  niches: TBrandedVsUgcNiche[],
  metric: TBrandedVsUgcMetric,
  side: TBrandedVsUgcSide
): TBrandedVsUgcNiche[] => {
  return [...niches].sort((a, b) => valueByMetric(b, metric, side) - valueByMetric(a, metric, side))
}

export const getDateVariables = (uploadDate?: string) => {
  const isCustomDate = uploadDate?.includes('custom')
  const isAllTime = uploadDate === 'all'
  const shouldUseTimeRange = !isCustomDate && !isAllTime

  if (shouldUseTimeRange) {
    const dateValue = getFormatedDateVariablesForTerritory(uploadDate)
    return {
      timeRange: dateValue ? { timeUnit: dateValue.timeUnit, timeValue: dateValue.timeValue } : null,
      publishedAt: null,
    }
  }

  return {
    timeRange: null,
    publishedAt: isCustomDate ? getUploadDateByValue(uploadDate) : ALL_TIME_RANGE_QUERY,
  }
}
